import { Link } from 'react-router-dom';
import {
  CARD_SCHEMA_V1,
  cardFallbackText,
  cardSchemaVersion,
  isSupportedCardSchema,
  normalizeSituationCard,
} from './travelCardModel';

export default function SituationCardMessage({ message }) {
  const card = normalizeSituationCard(message?.situationCard);
  if (!card) {
    return <p>{cardFallbackText(message, '此旅程狀況卡片目前無法顯示')}</p>;
  }
  if (!isSupportedCardSchema(card)) {
    return (
      <p>
        {cardFallbackText(message, '此卡片版本目前無法顯示')}
        <span className="visually-hidden"> schema {String(cardSchemaVersion(card))}</span>
      </p>
    );
  }

  const title = card.title || cardFallbackText(message, '未命名狀況');

  return (
    <article className="travel-msg-card" aria-label="旅程狀況">
      <p className="travel-msg-card__kicker">旅程狀況</p>
      <h2 className="travel-msg-card__title">{title}</h2>
      <p className="travel-msg-card__status">
        狀態：{card.situationStatusLabel}
        {card.situationStatus ? (
          <span className="visually-hidden"> ({card.situationStatus})</span>
        ) : null}
      </p>
      {card.situationTypeLabel ? <p>類型：{card.situationTypeLabel}</p> : null}
      {card.severityLabel ? <p>嚴重度：{card.severityLabel}</p> : null}
      {card.webRoute ? (
        <Link className="travel-msg-card__cta" to={card.webRoute}>
          查看旅程狀況
        </Link>
      ) : null}
      <span className="visually-hidden">schema {CARD_SCHEMA_V1}</span>
    </article>
  );
}
